<template>
    <div>
        <el-dialog
            title="商家信息"
            :visible.sync="shangjiaId.state"
            width="60%"
            @close="dialogVisibleClone"
            append-to-body
            class="dialog_container"
        >
            <div>
                <el-form
                    label-position="left"
                    label-width="120px"
                    :model="formData"
                    ref="formData"
                >
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="单位名称：" prop="unitName">
                                <el-input
                                    disabled
                                    v-model.trim="formData.unitName"
                                    placeholder="请输入单位名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="单位类型：" prop="unitType">
                                <el-radio-group v-model="formData.unitType">
                                    <el-radio label="0" disabled
                                        >有限责任公司</el-radio
                                    >
                                    <el-radio label="1" disabled
                                        >个体户</el-radio
                                    >
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人：" prop="contacts">
                                <el-input
                                    disabled
                                    v-model.trim="formData.contacts"
                                    placeholder="请输入联系人"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="联系方式：" prop="phone">
                                <el-input
                                    disabled
                                    v-model.trim="formData.phone"
                                    placeholder="请输入联系方式"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="法人代表："
                                prop="legalRepresent"
                            >
                                <el-input
                                    disabled
                                    v-model.trim="formData.legalRepresent"
                                    placeholder="请输入法人代表"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item label="法人身份证：" prop="idCode">
                                <el-input
                                    disabled
                                    v-model.trim="formData.idCode"
                                    placeholder="请输入法人身份证"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="证件号："
                                prop="certificateNumber"
                            >
                                <el-input
                                    disabled
                                    v-model.trim="formData.certificateNumber"
                                    placeholder="请输入证件号"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <!-- <el-form-item label="营业执照：">
								<el-input v-model.trim="formData.photo" placeholder="请输入营业执照"></el-input>
							</el-form-item> -->
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="地址：">
                                <el-input
                                    disabled
                                    v-model.trim="formData.address"
                                    placeholder="请输入营业执照"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>

            <div>
                <el-table
                    :data="allTableDataTwo"
                    border
                    style="width: 100%"
                    tooltip-effect="dark"
                    :header-cell-style="{
                        background: '#f1f1f1',
                        color: '#000',
                    }"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="waresName"
                        label="商品名称"
                        width="180"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="waresExplain"
                        label="商品说明"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="waresStock"
                        label="当前库存"
                        width="80"
                        align="center"
                    >
                    </el-table-column>
                    <!-- <el-table-column prop="address" label="地址" width="80" align="center">
					</el-table-column> -->
                    <el-table-column
                        prop="auditStatus"
                        label="状态"
                        width="80"
                        align="center"
                    >
                    </el-table-column>
                </el-table>
                <div style="height: 20px"></div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 40, 100]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                >
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    props: ["shangjiaId"],
    mounted() {
        this.getData()
    },
    data() {
        return {
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            dialogVisible: false,
            formData: {},
            total1: 0,
            allTableDataTwo: [],
        }
    },
    methods: {
        dialogVisibleClone() {
            this.$emit("setBuiness")
            this.dialogVisible = false
        },
        handleSizeChange(val) {
            this.query.pageSize = val
            this.allTableDataTwo = this.formData.waresList.slice(
                (this.query.pageNo - 1) * this.query.pageSize,
                this.query.pageNo * this.query.pageSize
            )
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.query.pageSize = val
            this.allTableDataTwo = this.formData.waresList.slice(
                (this.query.pageNo - 1) * this.query.pageSize,
                this.query.pageNo * this.query.pageSize
            )
        },
        getData() {
            request({
                url: "/sqyl/admin/unitInformation/info/get",
                method: "POST",
                data: {
                    id: this.shangjiaId.id,
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.formData = res.content
                    this.allTableDataTwo = res.content.waresList.slice(0, 10)
                    this.total1 = this.allTableDataTwo.length
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.dialog_container {
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
}
</style>
